module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_j_normal.b640128a.png";